import { EventEmitter } from 'events';

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toArray(r) {
  return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$1(r) || _nonIterableRest();
}

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var regeneratorRuntime$1 = {exports: {}};

var _typeof = {exports: {}};

_typeof.exports;

(function (module) {
	function _typeof(o) {
	  "@babel/helpers - typeof";

	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (_typeof));

var _typeofExports = _typeof.exports;

regeneratorRuntime$1.exports;

(function (module) {
	var _typeof = _typeofExports["default"];
	function _regeneratorRuntime() {
	  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
	    return e;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  var t,
	    e = {},
	    r = Object.prototype,
	    n = r.hasOwnProperty,
	    o = Object.defineProperty || function (t, e, r) {
	      t[e] = r.value;
	    },
	    i = "function" == typeof Symbol ? Symbol : {},
	    a = i.iterator || "@@iterator",
	    c = i.asyncIterator || "@@asyncIterator",
	    u = i.toStringTag || "@@toStringTag";
	  function define(t, e, r) {
	    return Object.defineProperty(t, e, {
	      value: r,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), t[e];
	  }
	  try {
	    define({}, "");
	  } catch (t) {
	    define = function define(t, e, r) {
	      return t[e] = r;
	    };
	  }
	  function wrap(t, e, r, n) {
	    var i = e && e.prototype instanceof Generator ? e : Generator,
	      a = Object.create(i.prototype),
	      c = new Context(n || []);
	    return o(a, "_invoke", {
	      value: makeInvokeMethod(t, r, c)
	    }), a;
	  }
	  function tryCatch(t, e, r) {
	    try {
	      return {
	        type: "normal",
	        arg: t.call(e, r)
	      };
	    } catch (t) {
	      return {
	        type: "throw",
	        arg: t
	      };
	    }
	  }
	  e.wrap = wrap;
	  var h = "suspendedStart",
	    l = "suspendedYield",
	    f = "executing",
	    s = "completed",
	    y = {};
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	  var p = {};
	  define(p, a, function () {
	    return this;
	  });
	  var d = Object.getPrototypeOf,
	    v = d && d(d(values([])));
	  v && v !== r && n.call(v, a) && (p = v);
	  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
	  function defineIteratorMethods(t) {
	    ["next", "throw", "return"].forEach(function (e) {
	      define(t, e, function (t) {
	        return this._invoke(e, t);
	      });
	    });
	  }
	  function AsyncIterator(t, e) {
	    function invoke(r, o, i, a) {
	      var c = tryCatch(t[r], t, o);
	      if ("throw" !== c.type) {
	        var u = c.arg,
	          h = u.value;
	        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
	          invoke("next", t, i, a);
	        }, function (t) {
	          invoke("throw", t, i, a);
	        }) : e.resolve(h).then(function (t) {
	          u.value = t, i(u);
	        }, function (t) {
	          return invoke("throw", t, i, a);
	        });
	      }
	      a(c.arg);
	    }
	    var r;
	    o(this, "_invoke", {
	      value: function value(t, n) {
	        function callInvokeWithMethodAndArg() {
	          return new e(function (e, r) {
	            invoke(t, n, e, r);
	          });
	        }
	        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      }
	    });
	  }
	  function makeInvokeMethod(e, r, n) {
	    var o = h;
	    return function (i, a) {
	      if (o === f) throw Error("Generator is already running");
	      if (o === s) {
	        if ("throw" === i) throw a;
	        return {
	          value: t,
	          done: !0
	        };
	      }
	      for (n.method = i, n.arg = a;;) {
	        var c = n.delegate;
	        if (c) {
	          var u = maybeInvokeDelegate(c, n);
	          if (u) {
	            if (u === y) continue;
	            return u;
	          }
	        }
	        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
	          if (o === h) throw o = s, n.arg;
	          n.dispatchException(n.arg);
	        } else "return" === n.method && n.abrupt("return", n.arg);
	        o = f;
	        var p = tryCatch(e, r, n);
	        if ("normal" === p.type) {
	          if (o = n.done ? s : l, p.arg === y) continue;
	          return {
	            value: p.arg,
	            done: n.done
	          };
	        }
	        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
	      }
	    };
	  }
	  function maybeInvokeDelegate(e, r) {
	    var n = r.method,
	      o = e.iterator[n];
	    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
	    var i = tryCatch(o, e.iterator, r.arg);
	    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
	    var a = i.arg;
	    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
	  }
	  function pushTryEntry(t) {
	    var e = {
	      tryLoc: t[0]
	    };
	    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
	  }
	  function resetTryEntry(t) {
	    var e = t.completion || {};
	    e.type = "normal", delete e.arg, t.completion = e;
	  }
	  function Context(t) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], t.forEach(pushTryEntry, this), this.reset(!0);
	  }
	  function values(e) {
	    if (e || "" === e) {
	      var r = e[a];
	      if (r) return r.call(e);
	      if ("function" == typeof e.next) return e;
	      if (!isNaN(e.length)) {
	        var o = -1,
	          i = function next() {
	            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
	            return next.value = t, next.done = !0, next;
	          };
	        return i.next = i;
	      }
	    }
	    throw new TypeError(_typeof(e) + " is not iterable");
	  }
	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
	    value: GeneratorFunctionPrototype,
	    configurable: !0
	  }), o(GeneratorFunctionPrototype, "constructor", {
	    value: GeneratorFunction,
	    configurable: !0
	  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
	    var e = "function" == typeof t && t.constructor;
	    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
	  }, e.mark = function (t) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
	  }, e.awrap = function (t) {
	    return {
	      __await: t
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
	    return this;
	  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
	    void 0 === i && (i = Promise);
	    var a = new AsyncIterator(wrap(t, r, n, o), i);
	    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
	      return t.done ? t.value : a.next();
	    });
	  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
	    return this;
	  }), define(g, "toString", function () {
	    return "[object Generator]";
	  }), e.keys = function (t) {
	    var e = Object(t),
	      r = [];
	    for (var n in e) r.push(n);
	    return r.reverse(), function next() {
	      for (; r.length;) {
	        var t = r.pop();
	        if (t in e) return next.value = t, next.done = !1, next;
	      }
	      return next.done = !0, next;
	    };
	  }, e.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function reset(e) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
	    },
	    stop: function stop() {
	      this.done = !0;
	      var t = this.tryEntries[0].completion;
	      if ("throw" === t.type) throw t.arg;
	      return this.rval;
	    },
	    dispatchException: function dispatchException(e) {
	      if (this.done) throw e;
	      var r = this;
	      function handle(n, o) {
	        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
	      }
	      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
	        var i = this.tryEntries[o],
	          a = i.completion;
	        if ("root" === i.tryLoc) return handle("end");
	        if (i.tryLoc <= this.prev) {
	          var c = n.call(i, "catchLoc"),
	            u = n.call(i, "finallyLoc");
	          if (c && u) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          } else if (c) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	          } else {
	            if (!u) throw Error("try statement without catch or finally");
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function abrupt(t, e) {
	      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
	        var o = this.tryEntries[r];
	        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
	          var i = o;
	          break;
	        }
	      }
	      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
	      var a = i ? i.completion : {};
	      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
	    },
	    complete: function complete(t, e) {
	      if ("throw" === t.type) throw t.arg;
	      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
	    },
	    finish: function finish(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
	      }
	    },
	    "catch": function _catch(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.tryLoc === t) {
	          var n = r.completion;
	          if ("throw" === n.type) {
	            var o = n.arg;
	            resetTryEntry(r);
	          }
	          return o;
	        }
	      }
	      throw Error("illegal catch attempt");
	    },
	    delegateYield: function delegateYield(e, r, n) {
	      return this.delegate = {
	        iterator: values(e),
	        resultName: r,
	        nextLoc: n
	      }, "next" === this.method && (this.arg = t), y;
	    }
	  }, e;
	}
	module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (regeneratorRuntime$1));

var regeneratorRuntimeExports = regeneratorRuntime$1.exports;

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntimeExports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regenerator);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * StreamConnector manages a streaming connection to a specified streamserver.dll URL.
 * It handles connection retries, error management, and emits relevant events to the StreamManager object.
 */
var StreamConnector = /*#__PURE__*/function (_EventEmitter) {
  /**
   * Creates an instance of StreamConnector
   * @param {string} url - The URL to connect to for streaming
   * @param {Object} [options={}] - Configuration options for the connector
   * @param {Object} [options.headers={}] - Custom HTTP headers
   * @param {number} [options.pollInterval=250] - Interval for polling in milliseconds
   * @param {number} [options.maxRetries=2] - Maximum number of retry attempts
   * @param {number} [options.retryBackoff=5000] - Backoff time in milliseconds before retrying
   * @param {number} [options.timeout=300] - Duration of the connection in seconds
   * @param {string} [options.logLevel='debug'] - Logging level
   */
  function StreamConnector(url) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, StreamConnector);
    _this = _callSuper$1(this, StreamConnector);
    _this.url = url;
    _this.options = _objectSpread$1({
      headers: {},
      pollInterval: 250,
      maxRetries: 5,
      retryBackoff: 5000,
      timeout: 300,
      logLevel: null,
      minExpectedDuration: 5
    }, options);
    _this.controller = null;
    _this.retryCount = 0;
    _this.connectionStartTime = null;
    return _this;
  }

  /**
   * Starts the streaming connection
   * @async
   * @returns {Promise<void>}
   */
  _inherits(StreamConnector, _EventEmitter);
  return _createClass(StreamConnector, [{
    key: "start",
    value: (function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.connectionStartTime = Date.now();
              this.controller = new AbortController();
              _context.next = 4;
              return this._fetchStream();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
    /**
     * Stops the streaming connection
     */
    )
  }, {
    key: "stop",
    value: function stop() {
      if (this.controller) {
        this.controller.abort();
      }
      this.connectionStartTime = null; // Reset connection start time
      this.retryCount = 0; // Reset retry count on manual stop
    }

    /**
     * Opens a connection to streamserver.dll and manages the incoming data, then restarts again on completion
     * @async
     * @private
     * @returns {Promise<void>}
     */
  }, {
    key: "_fetchStream",
    value: (function () {
      var _fetchStream2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response, reader, decoder, chunk, buffer, isSuccess, _yield$reader$read, done, value, lines, _iterator, _step, line, connectionDuration, minExpectedDuration;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.emit('connecting', {
                message: 'Connecting to stream',
                url: this.url
              });
              _context2.next = 4;
              return fetch(this.url, {
                method: 'GET',
                headers: this.options.headers,
                signal: this.controller.signal
              });
            case 4:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 14;
                break;
              }
              if (!(response.status === 403 || response.status === 511)) {
                _context2.next = 10;
                break;
              }
              // Emit a special 'forbidden' event just for 403/511 errors
              this.emit('forbidden', {
                status: response.status,
                message: 'Invalid token or session id'
              });
              this.emit('done', {
                success: false,
                message: 'Forbidden'
              });
              return _context2.abrupt("return");
            case 10:
              if (!(response.status === 404)) {
                _context2.next = 13;
                break;
              }
              this.emit('done', {
                success: false,
                message: 'Not Found'
              });
              return _context2.abrupt("return");
            case 13:
              throw new Error("Stream failed with status: ".concat(response.status));
            case 14:
              this.emit('connected');
              reader = response.body.getReader();
              decoder = new TextDecoder();
              chunk = '';
              buffer = '';
              isSuccess = false; // Continuously read stream data in chunks and emit either 'data' or 'error' events
            case 20:
              _context2.next = 23;
              return reader.read();
            case 23:
              _yield$reader$read = _context2.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              // Convert this chunk of byte data (Uint8Array format) to a string
              chunk = decoder.decode(value || new Uint8Array(), {
                stream: true
              });
              // Append the chunk to the buffer
              buffer += chunk;
              // an example buffer will look like: 'h 1735842465\nh 1735842468\nh 1735' // two heartbeat rows and an incomplete heartbeat
              lines = buffer.split('\n'); // now the lines array will look like: ['h 1735842465', 'h 1735842468', 'h 1735']
              // note: if the buffer ends with a newline, the last element will be an empty string, leading to something like ['h 1735842465', 'h 1735842468', '']
              buffer = lines.pop(); // Retain the incomplete line for the next chunk (note: in practice this is usually an empty string, since streamserver chunks are relatively small and rarely have incomplete lines)
              // now the lines array will look like: ['h 1735842465', 'h 1735842468']
              // example buffer now: 'h 1735'
              // ...and the next chunk will have the remaining part: '842467\n'

              // now emit 'data' or 'error' events for each line
              _iterator = _createForOfIteratorHelper(lines);
              _context2.prev = 31;
              _iterator.s();
            case 33:
              if ((_step = _iterator.n()).done) {
                _context2.next = 40;
                break;
              }
              line = _step.value;
              isSuccess = this._handleLine(line.trim());
              if (isSuccess) {
                _context2.next = 38;
                break;
              }
              return _context2.abrupt("break", 40);
            case 38:
              _context2.next = 33;
              break;
            case 40:
              _context2.next = 45;
              break;
            case 42:
              _context2.prev = 42;
              _context2.t0 = _context2["catch"](31);
              _iterator.e(_context2.t0);
            case 45:
              _context2.prev = 45;
              _iterator.f();
              return _context2.finish(45);
            case 48:
              if (!done) {
                _context2.next = 58;
                break;
              }
              this.emit('done', {
                success: isSuccess,
                message: {
                  status: response.status
                }
              });

              // Calculate connection duration in seconds
              connectionDuration = (Date.now() - this.connectionStartTime) / 1000; // Define a minimum expected duration (e.g., 10% of timeout)
              minExpectedDuration = typeof this.options.minExpectedDuration === 'number' ? this.options.minExpectedDuration : this.options.timeout * 0.1; // Only perform the runaway check if not purposely aborted
              if (!(!this.controller.signal.aborted && connectionDuration < minExpectedDuration)) {
                _context2.next = 56;
                break;
              }
              // Connection completed too quickly; possible runaway
              this.emit('streamconnector.error', {
                type: 'runaway',
                message: "Connection terminated prematurely after ".concat(connectionDuration.toFixed(2), " seconds.")
              });
              if (this.options.logLevel === 'debug') {
                console.error('StreamConnector: Runaway condition detected. Halting restarts.');
              }
              return _context2.abrupt("return");
            case 56:
              // Restart the stream if successful
              if (isSuccess) {
                // we made it past all the checks, and the stream is done, so we can restart
                if (this.options.logLevel === 'debug') console.info('Stream completed successfully. Restarting...');
                this.emit('restart', {
                  message: 'Stream restarting',
                  duration: (Date.now() - this.connectionStartTime) / 1000
                });
                this.start();
              }
              return _context2.abrupt("break", 60);
            case 58:
              _context2.next = 20;
              break;
            case 60:
              _context2.next = 65;
              break;
            case 62:
              _context2.prev = 62;
              _context2.t1 = _context2["catch"](0);
              if (_context2.t1.name === 'AbortError') {
                this.emit('done', {
                  success: true,
                  message: _context2.t1.message
                });
                this.emit('closed', {
                  message: 'Aborted'
                });
              } else {
                this.emit('done', {
                  success: false,
                  message: _context2.t1.message
                });
                this._handleError(_context2.t1);
              }
            case 65:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 62], [31, 42, 45, 48]]);
      }));
      function _fetchStream() {
        return _fetchStream2.apply(this, arguments);
      }
      return _fetchStream;
    }()
    /**
     * Processes each line of data received from the stream.
     * @private
     * @param {string} line - A single line of data from the stream (e.g. 't0 1736254854 423.86 100 7256357')
     * @returns {boolean} - Returns false if an error is encountered, true otherwise.
     */
    )
  }, {
    key: "_handleLine",
    value: function _handleLine(line) {
      // Check for error character in the line
      if (line.charAt(0).toLowerCase() === 'e') {
        console.error('StreamConnector: Error encountered:', line);
        var _line$slice$trim$spli = line.slice(1).trim().split(/\s+/),
          _line$slice$trim$spli2 = _toArray(_line$slice$trim$spli),
          errorType = _line$slice$trim$spli2[0],
          errorMessageParts = _line$slice$trim$spli2.slice(1);
        var errorMessage = errorMessageParts.join(' ');
        this.emit('error', {
          type: errorType,
          message: errorMessage
        });
        return false;
      }

      // Check for undefined string (usually means the XID is not found)
      if (/undefined/i.test(line)) {
        this.emit('error', {
          type: 'feed',
          message: 'Feed or XID not found'
        });
        return false;
      }

      // check for invalid starting characters (anything other than a,b,g,h,i,j,q,t,z,e,E optionally followed by an integer)
      if (!/^([abghijqtzeE]\d*(?: .*)?)+$/.test(line)) {
        this.emit('error', {
          type: 'invalid',
          message: "Malformed stream data: ".concat(encodeURIComponent(line))
        });
        return false;
      }

      // Reset retry count on valid data and emit 'data' event
      this.retryCount = 0;
      this.emit('data', line);
      return true;
    }

    /**
     * Handles errors encountered during the streaming process
     * @private
     * @param {Error} error - The error object encountered
     */
  }, {
    key: "_handleError",
    value: function _handleError(error) {
      var _this2 = this;
      // Clear any existing retry timeout to prevent multiple retries
      if (this.retryTimeout) {
        clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
      }
      this.emit('streamconnector.error', error);
      if (this.retryCount < this.options.maxRetries) {
        // Calculate exponential backoff delay
        var delay = this.options.retryBackoff * Math.pow(2, this.retryCount - 1);
        this.retryCount++;
        if (this.options.logLevel === 'debug') console.warn("StreamConnector: Retrying in ".concat(delay, "ms..."));

        // Schedule the next retry attempt
        this.retryTimeout = setTimeout(function () {
          _this2.start();
        }, delay);
      } else {
        // Max retries reached, emit 'closed' event and log the error
        if (this.options.logLevel === 'debug') console.error('StreamConnector: Max retries reached. Closing stream.');
        this.emit('closed', {
          message: 'Max retries reached'
        });
      }
    }
  }]);
}(EventEmitter);

//  Map of StreamSever event characters to eventemitter types
var eventMap = {
  a: 'streamserver.ask',
  b: 'streamserver.bid',
  g: 'streamserver.guid',
  h: 'streamserver.heartbeat',
  i: 'streamserver.init.start',
  j: 'streamserver.init.complete',
  q: 'streamserver.quote',
  t: 'streamserver.trade',
  z: 'streamserver.complete',
  e: 'streamserver.error'
};

// Map of readable field names per StreamServer event type
// e.g. 'a0 1736254854 423.86 100' will use this map to become { date: 1736254854000, price: 423.86, size: 100 }
var eventFieldMap = {
  a: ['date', 'price', 'size'],
  b: ['date', 'price', 'size'],
  g: ['guid'],
  h: ['date'],
  i: [],
  j: [],
  q: ['open', 'high', 'low', 'close', 'high52W', 'low52W', 'beta', 'divAnn', 'divPaymentDate', 'divExDate', 'epsTTM', 'shares', 'volume100D', 'openInterest'],
  t: ['date', 'price', 'size', 'volume', 'change', 'changePct'],
  z: [],
  e: ['errorType', 'errorMessage']
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * StreamManager handles the management of streaming connections, including
 * adding/removing symbols, handling authentication, and dispatching events
 */
var StreamManager = /*#__PURE__*/function (_EventEmitter) {
  /**
   * Creates an instance of StreamManager
   * @param {string} url - The base URL for StreamServer (no query parameters)
   * @param {string} environment - Will automatically choose the shared StreamServer url if provided (e.g., 'dev', 'qa', 'prod')
   * @param {Object} [options={}] - Configuration options for the stream
   * @param {number} [options.version=1] - API version
   * @param {number} [options.rollup=250] - Interval in ms at which updates are sent
   * @param {number} [options.timeout=300] - Connection duration in seconds
   * @param {Object} [options.headers={}] - Custom HTTP headers
   * @param {number} [options.retryBackoff=2000] - Base retry backoff in ms
   * @param {number} [options.maxRetries=5] - Maximum retry attempts
   * @param {string|null} [options.feedSelectionGroup=null] - Feed selection group for quotes
   * @param {boolean} [options.quoteBestAvailable=true] - Fail over to delayed quotes if realtime fails
   * @param {string} [options.logLevel='debug'] - Logging level ('error', 'warn', 'info', 'debug')
   */
  function StreamManager() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, StreamManager);
    _this = _callSuper(this, StreamManager);
    _this.options = _objectSpread({
      environment: 'dev',
      feedSelectionGroup: null,
      // The Feed Selection group to use for the quote
      headers: {},
      logLevel: null,
      // 'debug'
      maxRetries: 5,
      // Maximum retry attempts
      quoteBestAvailable: true,
      // Whether to fail over to delayed when a realtime quote fails
      retryBackoff: 2000,
      // Base retry backoff in ms
      rollup: 250,
      // The interval in milliseconds at which updates are sent
      timeout: 300,
      // The duration of the connection in seconds
      version: 1
    }, options);
    _this.connector = null;
    _this.symbols = [];
    _this.sessionId = null;
    _this.token = null;
    return _this;
  }

  /**
   * Sets the Bearer Token for the Authorization header
   * This is an alternative to using a Session ID
   * @param {string} token - The Bearer token
   */
  _inherits(StreamManager, _EventEmitter);
  return _createClass(StreamManager, [{
    key: "setBearerToken",
    value: function setBearerToken(token) {
      this.token = token;
      this.setHeader('Authorization', "Bearer ".concat(token));
    }

    /**
     * Removes the Bearer Token from the stream
     */
  }, {
    key: "removeBearerToken",
    value: function removeBearerToken() {
      this.token = null;
      delete this.options.headers.Authorization;
    }

    /**
     * Sets the Session ID for query string authentication
     * This is an alternative to using a Bearer Token
     * @param {string} sessionId - The session ID
     */
  }, {
    key: "setSessionId",
    value: function setSessionId(sessionId) {
      this.sessionId = sessionId;
    }

    /**
     * Removes the Session ID from the stream
     */
  }, {
    key: "removeSessionId",
    value: function removeSessionId() {
      this.sessionId = null;
    }

    /**
     * Adds or updates a custom HTTP header
     * @param {string} key - The header name
     * @param {string} value - The header value
     */
  }, {
    key: "setHeader",
    value: function setHeader(key, value) {
      this.options.headers[key] = value;
    }

    /**
     * Removes a custom HTTP header
     * @param {*} key - The header name
     */
  }, {
    key: "removeHeader",
    value: function removeHeader(key) {
      delete this.options.headers[key];
    }

    /**
     * Adds a symbol to the stream
     * @param {string} xid - The unique identifier for the symbol
     * @param {string} [events='t'] - Events to subscribe to for the symbol
     */
  }, {
    key: "addSymbol",
    value: function addSymbol(xid) {
      var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 't';
      if (xid) {
        this.symbols.push({
          xid: xid.toString(),
          events: events
        });
      }
    }

    /**
     * Removes a symbol from the stream
     * @param {string} xid - The unique identifier for the symbol to remove
     */
  }, {
    key: "removeSymbol",
    value: function removeSymbol(xid) {
      this.symbols = this.symbols.filter(function (s) {
        return s.xid.toString() !== xid.toString();
      });
    }

    /**
     * Replaces all symbols in the stream with a new set
     * This is an alternative to using addSymbol or removeSymbol
     * @param {Array<{xid: string, events?: string}>} newSymbols - The new set of symbols
     */
  }, {
    key: "setSymbols",
    value: function setSymbols(newSymbols) {
      this.symbols = newSymbols.map(function (symbol) {
        return {
          xid: symbol.xid.toString(),
          events: symbol.events || 't'
        };
      });
    }

    /**
     * Starts the streaming connection manually
     */
  }, {
    key: "start",
    value: function start() {
      if (this.options.logLevel === 'debug') console.info('StreamManager: start() called.');
      this._updateStream();
    }

    /**
     * Stops the streaming connection manually
     */
  }, {
    key: "stop",
    value: function stop() {
      if (this.options.logLevel === 'debug') console.info('StreamManager: stop() called.');
      if (this.connector) {
        this.connector.stop();
      }
    }

    /**
     * Builds the base StreamServer URL (i.e. where streamserver.dll is located)
     * @private
     * @param {*} options - The options object
     * @returns {string} - The base URL for the stream
     */
  }, {
    key: "_buildBaseURL",
    value: function _buildBaseURL(options) {
      if (options.url) return options.url; // url takes precedence
      if (options.environment) {
        return "https://streamer.".concat(options.environment, ".services.mdgapp.net/streamserver/streamserver.dll");
      }
      return null;
    }

    /**
     * Builds the final streamserver URL (baseURL + query params)
     * This will be passed to the StreamConnector.
     * @private
     * @returns {string} - The complete streamserver URL
     */
  }, {
    key: "_buildURL",
    value: function _buildURL() {
      var baseUrl = this._buildBaseURL(this.options);
      var queryParts = [];
      queryParts.push("Version=".concat(this.options.version));
      queryParts.push("Rollup=".concat(this.options.rollup));
      queryParts.push("Timeout=".concat(this.options.timeout));
      queryParts.push('Heartbeat');
      if (this.sessionId) {
        queryParts.push("sessionid=".concat(this.sessionId));
      }
      if (typeof this.options.feedSelectionGroup === 'string') {
        queryParts.push("FeedSelection.Group=".concat(this.options.feedSelectionGroup));
      }
      if (this.options.quoteBestAvailable) {
        queryParts.push('Quote.BestAvailable=1');
      }
      this.symbols.forEach(function (symbol, index) {
        queryParts.push("Quote=".concat(index, ",").concat(symbol.xid, ",").concat(symbol.events, ",1"));
      });
      var queryString = queryParts.join('&');
      return "".concat(baseUrl, "?").concat(queryString);
    }

    /**
     * Detaches all listeners from the current StreamConnector
     * @private
     */
  }, {
    key: "_detachStreamConnectorListeners",
    value: function _detachStreamConnectorListeners() {
      if (this.connector) {
        this.connector.removeAllListeners();
      }
    }

    /**
     * Updates and starts or restarts the stream
     * This is used when initializing the stream or when changes occur
     * @private
     */
  }, {
    key: "_updateStream",
    value: function _updateStream() {
      if (!this.sessionId && !this.token) {
        console.error('StreamManager: No session ID or token set');
        return;
      }
      this._detachStreamConnectorListeners();
      var url = this._buildURL();
      if (this.connector) this.connector.stop();
      this.connector = new StreamConnector(url, {
        headers: this.options.headers,
        logLevel: this.options.logLevel
      });
      this._attachStreamConnectorListeners();
      this.connector.start();
    }

    /**
     * Attaches listeners to all relevant events from the StreamConnector
     * @private
     */
  }, {
    key: "_attachStreamConnectorListeners",
    value: function _attachStreamConnectorListeners() {
      var _this2 = this;
      this.connector.on('closed', function (msg) {
        return _this2._handleStreamClosed(msg);
      });
      this.connector.on('complete', function (msg) {
        return _this2._handleComplete(msg);
      });
      this.connector.on('connected', function () {
        return _this2._handleConnected();
      });
      this.connector.on('connecting', function (data) {
        return _this2._handleConnecting(data);
      });
      this.connector.on('data', function (line) {
        return _this2._handleData(line);
      });
      this.connector.on('done', function (msg) {
        return _this2._handleDone(msg);
      });
      this.connector.on('error', function (err) {
        return _this2._handleStreamError(err);
      });
      this.connector.on('forbidden', function (err) {
        return _this2._handleForbidden(err);
      });
      this.connector.on('restart', function (msg) {
        return _this2._handleStreamRestart(msg);
      });
      this.connector.on('streamconnector.error', function (err) {
        return _this2._handleStreamConnectorError(err);
      }); // has a "streamconnector" prefix to avoid confusion
    }

    // Event Handlers

    /**
     * Handles the 'complete' event from the StreamConnector
     * This event is emitted when the 'z' event is received from StreamServer, indicating the stream is complete
     * @param {Object} msg - The message associated with the event
     * @private
     */
  }, {
    key: "_handleComplete",
    value: function _handleComplete(msg) {
      this._dispatchEvent('streamserver.complete', msg);
    }

    /**
     * Handles the 'done' event from the StreamConnector
     * This event is emitted when the stream connection is closed or completed,
     * regardless whether we received a 'z' event (see _handleComplete)
     * In practice, though, usually both 'done' and 'complete' events are emitted.
     * @param {Object} msg - The message associated with the event
     * @private
     */
  }, {
    key: "_handleDone",
    value: function _handleDone(msg) {
      this._dispatchEvent('streamconnector.done', msg);
    }

    /**
     * Handles the 'connecting' event from the StreamConnector
     * @private
     */
  }, {
    key: "_handleConnecting",
    value: function _handleConnecting(data) {
      this._dispatchEvent('streamconnector.connecting', data);
    }

    /**
     * Handles the 'connected' event from the StreamConnector
     * @private
     */
  }, {
    key: "_handleConnected",
    value: function _handleConnected() {
      this._dispatchEvent('streamconnector.connected', {});
    }

    /**
     * Handles incoming data lines from the stream
     * @param {string} line - A single line of data from the stream
     * @private
     */
  }, {
    key: "_handleData",
    value: function _handleData(line) {
      if (!line || !line.length) return;
      var eventType = line.charAt(0).toLowerCase();
      var rawData = line.slice(1).trim();
      var parsedData = this._parseEventData(eventType, rawData);
      var eventName = eventMap[eventType];
      if (eventName && parsedData) {
        this._dispatchEvent(eventName, {
          raw: line,
          data: parsedData
        });
      }
    }

    /**
     * Handles errors emitted by StreamServer
     * @param {Error} err - The error object
     * @private
     */
  }, {
    key: "_handleStreamError",
    value: function _handleStreamError(err) {
      this._dispatchEvent('streamserver.error', err);
    }

    /**
     * Handles errors emitted by StreamConnector
     * @param {Error} err - The error object
     * @private
     */
  }, {
    key: "_handleStreamConnectorError",
    value: function _handleStreamConnectorError(err) {
      this._dispatchEvent('streamconnector.error', err);
    }

    /**
     * Handles the 'closed' event from the StreamConnector
     * @private
     */
  }, {
    key: "_handleStreamClosed",
    value: function _handleStreamClosed(msg) {
      this._dispatchEvent('streamconnector.closed', msg);
    }

    /**
     * Handles the 'forbidden' event, typically due to invalid or expired tokens/sessionid
     * @param {Object} err - The error details
     * @private
     */
  }, {
    key: "_handleForbidden",
    value: function _handleForbidden(err) {
      // emit a general forbidden error event
      this._dispatchEvent('streamconnector.forbidden', {
        message: "".concat(err.message)
      });
    }

    /**
     * Handles the 'restart' event from the StreamConnector
     * @private
     */
  }, {
    key: "_handleStreamRestart",
    value: function _handleStreamRestart(msg) {
      this._dispatchEvent('streamconnector.restart', msg);
    }

    /**
     * Parses raw event data into a structured object
     * @param {string} eventType - The type of the event (e.g., 't' for trade)
     * @param {string} rawData - The raw data string from the stream minus the eventType (e.g., '0 123.45 100')
     * @param {Object} eventFieldMap - Mapping of event types to their respective fields
     * @returns {Object} - The parsed data object
     * @private
     */
  }, {
    key: "_parseEventData",
    value: function _parseEventData() {
      var _this3 = this;
      var eventType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var rawData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (typeof rawData !== 'string') return {};
      var fields = eventFieldMap[eventType];
      var parts = rawData.split(/\s+/);
      if (!fields || !rawData || parts.length === 0) {
        return {};
      }
      var parsedObject = {};
      // Extract xid for all events EXCEPT xid-agnostic events like heartbeat, init, guid, etc.
      if (!['h', 'i', 'j', 'z', 'g', 'e', 'E'].includes(eventType)) {
        var _this$symbols$index;
        // Extract symbol index (e.g., '0' as the first array value would extract 0) to get the mapped xid
        var index = parseInt(parts.shift(), 10);
        var xid = (_this$symbols$index = this.symbols[index]) === null || _this$symbols$index === void 0 ? void 0 : _this$symbols$index.xid;
        if (xid) parsedObject.xid = xid;
      }
      fields.forEach(function (field, i) {
        var value = parts[i];
        if (field === 'date' && value !== undefined) {
          // Convert date to milliseconds
          value = Number(value) * 1000;
        }
        parsedObject[field] = _this3._convertToType(value);
      });
      return parsedObject;
    }

    /**
     * Converts raw string values to appropriate data types
     * @param {string} value - The raw value to convert
     * @returns {number|string|null} - The converted value
     * @private
     */
  }, {
    key: "_convertToType",
    value: function _convertToType(value) {
      if (value === undefined || value === '!' || value === null) return null;
      var num = Number(value);
      return isNaN(num) ? value : num;
    }

    /**
     * Dispatches the stream event to any listeners
     * @param {string} name - The name of the event
     * @param {Object} detail - The data to pass with the event
     * @private
     */
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(name, detail) {
      if (this.options.logLevel === 'debug') console.info("StreamManager: Dispatched event: ".concat(name), detail);
      this.emit(name, detail);
    }
  }]);
}(EventEmitter);

export { StreamConnector, StreamManager };
//# sourceMappingURL=index.esm.js.map
